import CircularProgress from './CircularProgress';
import styles from './ApplyingEditsBadge.module.scss';

/**
 * Progress badge for Paste & Apply, in the top left of the card being pasted
 * onto. Saving the config, re-rendering the picture and uploading it over the
 * stored file takes long enough to need saying so, and sitting on the card is
 * what says which of them is busy - several can be pasted onto at once.
 *
 * A paste started from the lightbox shows that lightbox's own loader instead,
 * so this only has the card grid to cover.
 */
export const ApplyingEditsBadge = ({ show }) => {
  if (!show) return null;

  return (
    <div className={styles.root} role="status" aria-live="polite">
      {/* White, not the papaya default: the pill it sits on is papaya. */}
      <CircularProgress size={12} thickness={2} borderColor="#ffffff" />
      <span>Applying edits</span>
    </div>
  );
};

export default ApplyingEditsBadge;
